var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrigynLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 63.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8303 50.3485C42.4222 50.3485 42.0308 50.5125 41.7422 50.8044C41.4536 51.0964 41.2915 51.4923 41.2915 51.9051V70.7266C41.2924 73.1176 42.2264 75.4116 43.8905 77.1096C45.5545 78.8076 47.814 79.7723 50.1775 79.7939H52.3455C51.786 79.7695 51.2572 79.528 50.869 79.1197C50.4808 78.7113 50.2629 78.1674 50.2606 77.6008V51.9051C50.2606 51.4926 50.0987 51.097 49.8105 50.8051C49.5223 50.5132 49.1314 50.349 48.7236 50.3485H42.8303Z",
    fill: "url(#paint0_linear_141_6395)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2915 70.7249V78.48C41.2908 79.8436 41.5557 81.194 42.0712 82.4539C42.5866 83.7139 43.3425 84.8587 44.2956 85.823C45.2487 86.7873 46.3803 87.5521 47.6257 88.0738C48.8711 88.5955 50.206 88.8637 51.554 88.8632H72.3298C74.5779 88.6797 76.6751 87.6462 78.2036 85.9685C79.7321 84.2909 80.5797 82.0923 80.5775 79.8108V77.5823C80.5731 78.1663 80.3405 78.7248 79.9306 79.136C79.5206 79.5472 78.9665 79.7777 78.3892 79.7772L52.3511 79.7922H50.2716C47.8929 79.7932 45.6111 78.8386 43.9278 77.1383C42.2446 75.438 41.2976 73.1312 41.2952 70.7249H41.2915Z",
    fill: "url(#paint1_linear_141_6395)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3916 38H39.4334C38.6769 38 38.1215 38.629 38.0809 39.3924C37.9935 41.4379 37.6487 43.4638 37.0551 45.4211C36.8244 46.2405 37.341 47.1009 38.1824 47.1009H78.3743C84.4115 47.1625 89.5409 52.0975 89.5409 58.3315V48.3963C89.541 46.3074 88.9191 44.267 87.7564 42.5408C86.5936 40.8147 84.9439 39.4827 83.0221 38.7186L82.9428 38.6887L82.9114 38.6757C81.7458 38.227 80.5089 37.9981 79.2618 38H52.3916Z",
    fill: "url(#paint2_linear_141_6395)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5604 49.2997H80.5733V77.5506V79.7792C80.575 82.0605 79.7273 84.2589 78.1989 85.9364C76.6705 87.6139 74.5736 88.6476 72.3257 88.8315C72.0876 88.8502 71.8496 88.8614 71.6079 88.8614H79.2762C80.6242 88.8626 81.9592 88.595 83.2049 88.0737C84.4505 87.5524 85.5823 86.7878 86.5355 85.8235C87.4887 84.8593 88.2446 83.7144 88.7599 82.4543C89.2752 81.1942 89.5398 79.8437 89.5386 78.4801V58.4043C89.5391 55.4135 88.3672 52.5445 86.2799 50.4263C84.1925 48.3081 81.36 47.1136 78.4034 47.1047C78.9763 47.1087 79.5245 47.3417 79.9282 47.7529C80.3319 48.1641 80.5585 48.7201 80.5585 49.2997",
    fill: "url(#paint3_linear_141_6395)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_141_6395",
    x1: 46.8194,
    y1: 50.3485,
    x2: 46.8194,
    y2: 79.7939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#05612D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#017E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#138838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E963C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#41A13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4CA740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#50A941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#57AB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#6CAF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#70B02D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_141_6395",
    x1: 80.5775,
    y1: 79.794,
    x2: 41.2915,
    y2: 79.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#1F9CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1470B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1A5EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#214B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#254088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#263C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#25397E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#223169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1E2448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E2345"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_141_6395",
    x1: 42.0461,
    y1: 32.0964,
    x2: 89.1651,
    y2: 58.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3A30F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E96316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#E1321B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DE1F1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#DC1820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB1222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_141_6395",
    x1: 80.577,
    y1: 88.8651,
    x2: 80.577,
    y2: 47.1047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#293170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#313272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#473577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6A3A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#793C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#803483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#852E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#59132A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#551022"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrigynLogo);
export default __webpack_public_path__ + "static/media/origynLogo.2486e1bbd1310d97fd07da1c6636eae3.svg";
export { ForwardRef as ReactComponent };